﻿export class UserInfo {
    userId: string;
    displayName: string;
}